module.exports = __webpack_public_path__ + "static/media/just_married_car.4157e8a0.svg";